import { createSlotRecipe } from './runtime.js';

const chatCodeSurfaceConfig = {"name":"chatCodeSurface","slots":["root","header","title","stat","additions","deletions","scroll","surface","line","gutter"],"defaultVariants":{"kind":"context"},"variantMap":{"kind":["added","context","error","removed"]}}

export const chatCodeSurface = /* @__PURE__ */ createSlotRecipe(chatCodeSurfaceConfig)